import reduxModule from "./redux";
import { useFile } from "./hook";

export { useFile };

export default reduxModule;
